module.exports = __webpack_public_path__ + "img/完成.49c8ab70.svg";